// extracted by mini-css-extract-plugin
export default {"searchBar":"rK8cwkCXtD5FUlSVi39R","topShadow":"tnGsRpBF2JzodmepWP9x","gap":"DVd1f1euYO74qx8D9D0h","borderBottom":"H0Su15mzbHakqzfE9eUX"};